import React from "react";
import { useLocation } from "react-router-dom";
import Header from "./components/Header";
import AdminHeader from "./components/AdminHeader";

const Layout = ({ children }) => {
  const location = useLocation();
  const path = location.pathname;

  const mobileRoutes = ["/mobilehome", "/stock", "/purchaseDashboard","/receiptReport", "/purchasePO", "/addPurchase", "/editPurchase", "/addExpenditure", "/purchaseExpenditure", "/purchaseStock", "/expenditure","/expenditure_v1", "/requisition", "/adminInvoice", "/ExpenditureListKitchen", "/expenditureListKitchen2", "/requisitionPO", "/subKitchen", "/Sub_kichen_home", "/addkitchen", "/ExpenditureListSubKitchen", "/expenditureSub", "/PurchaseReportList", "/PurchaseReport", "/PurchaseItemsList", "/CurrentDateList", "/PastDataList", "/KitchenProjectHome", "/ProjectAdminKitchen", "/PurchaseList","/CurrentDateListv1","/WestDateList","/POReport","/ExpenditureListKitchenSub","/expenditureSubNew","/MealsHome","/MealsReport"];
  const adminRoute = ["/dashboard", "/DashboardvMain1","/requisition_v1","/dashboard_main","/dashboard_v3","/StockRegisterReport", "/Test", "/userList", "/vendorlist", "/kitchenList", "/itemsList", "/operatorList", "/adminStock", "/adminExpenditure", "/adminExpenditure2", "/requisitionadmin", "/RequisitionDetails", "ExpenditureKitchenDetails", "expenditurekitchendetails2", "/categorylist", "/purchaseorder", "/POListMenu", "/kitchenStock/:kitchenId", "/POList", "/requisitionList", "/RequisitionListPO", "/requisition-admin-list", "/Dashboardv1", "/Dashboardv2",];

  const isMobileRoute = mobileRoutes.includes(path);
  const isAdminRoute = adminRoute.includes(path);

  return (
    <>
      {/* {isMobileRoute && <Header />} */}
      {isMobileRoute && <AdminHeader />}
      {isAdminRoute && <AdminHeader />}
      <main>{children}</main>
    </>
  );
};

export default Layout;
